import styled from '@emotion/styled';
import React, { type ReactNode } from 'react';
import Arrow from '../../new-assets/arrow.svg';
import { Button } from '../../new-components/Button';
import type { ITheme } from '../../themer';
import themed from '../../themer/themed';
import Responsive from '../../utils/Responsive';
import { ArrowLink, isRelativeUrl, StyledIconLink } from '../Link';
import { markdownListStyles } from '../../../features/content-sections/ui/components/markdownListStyles';

export const StyledHighlightContent = styled.div<{}, ITheme>`
	min-width: 50%;
	flex: 1 0 50%;
	padding: ${themed(({ highlight }) => highlight.padding.default)};

	// IE11 Fix
	max-width: 50%;

	p:last-of-type {
		margin-bottom: 0;
	}

	${StyledIconLink} {
		margin-top: 1em;
		display: inline-flex;
	}

	${markdownListStyles}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding: ${themed(({ highlight }) => highlight.padding.mobileXL)};
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobile')}) {
		padding: ${themed(({ highlight }) => highlight.padding.mobile)};
	}
`;

interface IHighlightContentProps {
	title: string;
	children?: ReactNode;
	linkHref?: string;
	linkTitle?: string;
	showLinkAsButton?: boolean;
}

export const HighlightContent = ({
	title,
	children,
	linkHref,
	linkTitle,
	showLinkAsButton,
}: IHighlightContentProps) => (
	<StyledHighlightContent>
		<h2>{title}</h2>
		{children}
		{linkTitle &&
			linkHref &&
			(showLinkAsButton ? (
				<Button href={linkHref} variant="primary" icon={<Arrow />}>
					{linkTitle}
				</Button>
			) : (
				<ArrowLink
					href={linkHref}
					target={isRelativeUrl(linkHref) ? undefined : '_blank'}
				>
					{linkTitle}
				</ArrowLink>
			))}
	</StyledHighlightContent>
);
